"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnsQueryGrid = exports.mapResultNode = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const TableColumnsDisplayGrid_1 = require("./TableColumnsDisplayGrid");
function selectConnectionListResult(resultData) {
    var _a;
    return (_a = resultData.tablesConnection.nodes[0]) === null || _a === void 0 ? void 0 : _a.columnsConnection;
}
function mapResultNode(node, resultData) {
    var _a;
    const table = resultData.tablesConnection.nodes[0];
    const vizportalId = table.__typename === 'DatabaseTable'
        ? table.vizportalId
        : '';
    return Object.assign(Object.assign({}, node), { labels: node
            .labels
            .concat(node.upstreamColumns ? (0, catalog_core_1.filterOutNullAndUndefined)(node.upstreamColumns).flatMap(t => t.labels) : []), tags: (0, catalog_core_1.filterOutNullAndUndefined)(node.tags.map(t => t.name)), datasourceCount: node.downstreamDatasourcesConnection ? node.downstreamDatasourcesConnection.totalCount : null, sheetCount: node.downstreamSheetsConnection ? node.downstreamSheetsConnection.totalCount : null, tableId: (_a = table === null || table === void 0 ? void 0 : table.id) !== null && _a !== void 0 ? _a : '', vizportalId: vizportalId });
}
exports.mapResultNode = mapResultNode;
function TableColumnsQueryGrid(props) {
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.TableColumnsByIdDocument, partialQueryVariables: {
            tableId: props.tableId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode, hackyUpdateNumber: props.hackyUpdateNumber }, ({ rowStore }) => (react_1.default.createElement(TableColumnsDisplayGrid_1.TableColumnsDisplayGrid, { tableType: props.tableType, rowStore: rowStore, selectedKeys: props.selectedKeys, orderBy: props.orderBy, updateSelectionForKey: props.updateSelectionForKey, updateSortOrder: props.updateSortOrder, rowCount: props.rowCount, tableVizportalId: props.tableVizportalId }))));
}
exports.TableColumnsQueryGrid = TableColumnsQueryGrid;
//# sourceMappingURL=TableColumnsQueryGrid.js.map